<template>
  <div class="wrapper">
    <el-image class="top" style="width: 100%" src="https://mlh5.oss-cn-beijing.aliyuncs.com/demo/page/static/img/01.png"
      fit="contain" alt="码路科技"></el-image>
    <div class="title">视频案例</div>
    <div class="tabs">
      <!-- <div class="tab_title">案例列表</div> -->
      <div class="tab" @click="activeTab(0)" :class="value == 0 ? 'active' : ''">
        全部
      </div>
      <div class="tab" v-for="(item, index) in options" :class="value == item.value ? 'active' : ''" :key="index"
        @click="activeTab(item.value)">
        {{ item.label }}
      </div>
    </div>
    <!-- <div class="selectBar_hb">
      <el-select v-model="value" @change="change" placeholder="请选择分类">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div> -->
    <div class="data-list-p">
      <template v-for="item in list">
        <div class="video-data-item">
          <div style="font-size: 20px;margin-bottom: 5px;">{{ item.name }}</div>
          <video preload="none" style="width: 650px;max-height: 400px;" :src="item.src" :poster="item.img"  controls></video>
        </div>
      </template>
    </div>

    <!-- <div class="title">我们团队</div> -->
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      list: [],
      img_list: [],
      all_list: [],
      input: "",
      value: "",
      options: [],
    };
  },
  mounted() {
    this.$http({
      method: "get",
      url: "https://mlh5.oss-cn-beijing.aliyuncs.com/demo/page/data.json",
      // url: "static/data.json",
    })
      .then((res) => {
        this.options = res.data.video_type.map((type) => {
          return {
            label: type.name,
            value: type.id,
            Pinyin: type.Pinyin,
          };
        });

        this.img_list = res.data.video.map((item) => item.img);
        this.list = res.data.video;
        this.all_list = res.data.video;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    activeTab(value) {
      this.value = value;
      if (value == 0) {
        this.list = this.all_list;
        return;
      }
      this.list = this.all_list.filter((item) => {
        return item.type_id == value;
      });
      console.log(value);
    },
  },
};
</script>

<style lang="scss">
.el-image-viewer__btn {
  display: none !important;
}

.el-image-viewer__canvas {
  pointer-events: none;
}

.video-data-item {
  margin-bottom: 20px;
  // width: 48%;
  flex: 1;
  background-color: #262626;
  padding: 10px;
  border-radius: 5px;
  margin-right: 20px;
  text-align: center;
}

@import "../assets/common.scss";
</style>


// WEBPACK FOOTER //
// src/pages/video.vue